import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import MyJustificationsForm from "./MyJustificationsForm";

const CallViewMyJustifications = ({ match }) => {

    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <MyJustificationsForm id={match.params.id} context={"view"} />
        </div>
    );
}

export default CallViewMyJustifications;